import script from "./RoutePreloader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutePreloader.vue?vue&type=script&setup=true&lang=ts"

import "./RoutePreloader.vue?vue&type=style&index=0&id=61053b7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61053b7e"]])

export default __exports__